import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ClaimNoteIcon from 'products/nomad_insurance/assets/img/claims/claim-note.svg';
import ClaimNoteModal from '../../../ClaimNoteModal';
import useClaimProgression from '../../../../hooks/useClaimProgression';
import { StyledClaimNoteButton } from './styled';

const ClaimNoteButton = ({ claim }) => {
  const [showModal, setShowModal] = useState(false);
  const { isDraft, isComplete, isDeclined } = useClaimProgression(claim);

  if (isDraft || isComplete || isDeclined) return null;

  return (
    <>
      <ClaimNoteModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        claim={claim}
      />
      <StyledClaimNoteButton
        color="fountainBlue"
        thickness="thin"
        disabled={!claim.note}
        onClick={() => setShowModal(true)}
      >
        <img src={ClaimNoteIcon} alt="Claim note" />
        View note
      </StyledClaimNoteButton>
    </>
  );
};

ClaimNoteButton.propTypes = {
  claim: PropTypes.any.isRequired
};

export default ClaimNoteButton;
